'use client'

import type { DialogAPI } from '@fukku/dialog/Dialog'
import {
	createContext,
	type RefObject,
	useContext,
	useMemo,
	useRef,
} from 'react'

export type SizeGuideContextType = {
	sizeGuideDialogRef: RefObject<DialogAPI | null>
}

type SizeGuideDialogRefProviderProps = {
	readonly children: React.ReactNode
}

export const SizeGuideContext = createContext<SizeGuideContextType | undefined>(
	undefined
)

export function SizeGuideDialogRefProvider({
	children,
}: SizeGuideDialogRefProviderProps): React.ReactNode {
	const sizeGuideDialogRef = useRef<DialogAPI>(null)

	const value = useMemo(
		() => ({
			sizeGuideDialogRef,
		}),
		[]
	)

	return (
		<SizeGuideContext.Provider value={value}>
			{children}
		</SizeGuideContext.Provider>
	)
}

/** @throws {Error} If useSizeGuideDialogRef is used without SizeGuideDialogRefProvider */
export const useSizeGuideDialogRef = (): SizeGuideContextType => {
	const context = useContext(SizeGuideContext)
	if (!context) {
		throw new Error(
			'useSizeGuideDialogRef must be used within a SizeGuideDialogRefProvider'
		)
	}
	return context
}
